import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import { Input, InputProps } from '@nextui-org/react';
import React, { useState } from 'react';

interface PasswordInputProps extends Omit<InputProps, 'type'> {
  label: string;
  value?: string;
  onValueChange?: (value: string) => void;
  placeholder?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  isInvalid?: boolean;
  errorMessage?: string;
  variant?: 'bordered' | 'flat' | 'faded' | 'underlined';
  size?: 'sm' | 'md' | 'lg';
  defaultVisible?: boolean;
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
  label,
  value,
  onValueChange,
  placeholder,
  isRequired = false,
  isDisabled = false,
  isInvalid = false,
  errorMessage,
  variant = 'bordered',
  size = 'md',
  defaultVisible = false,
  ...props
}) => {
  const [isVisible, setIsVisible] = useState(defaultVisible);

  const toggleVisibility = () => setIsVisible(!isVisible);

  return (
    <Input
      label={label}
      type={isVisible ? 'text' : 'password'}
      value={value}
      onValueChange={onValueChange}
      placeholder={placeholder}
      isRequired={isRequired}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      errorMessage={errorMessage}
      variant={variant}
      size={size}
      endContent={
        <button className='focus:outline-none' type='button' onClick={toggleVisibility} disabled={isDisabled}>
          {isVisible ? (
            <EyeSlashIcon className='h-4 w-4 text-gray-400 hover:text-gray-600' />
          ) : (
            <EyeIcon className='h-4 w-4 text-gray-400 hover:text-gray-600' />
          )}
        </button>
      }
      {...props}
    />
  );
};
